"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@mui/styles");

var _material = require("@mui/material");

var StyledStepLabel = (0, _styles.withStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return (0, _styles.createStyles)({
    label: {
      '&$alternativeLabel': {
        marginTop: spacing(1),
        textTransform: 'uppercase',
        fontSize: 14,
        color: palette.common.white
      }
    },
    alternativeLabel: {}
  });
})(_material.StepLabel);
var _default = StyledStepLabel;
exports.default = _default;